import { loaderService } from "../../../common/custom-loader/loader-service";
import { GET_STAKEHOLDER_BY_URN } from '../../../common/URLs';

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import apiClient from "../../../axios";

export function rescgetStakeholderType(urn, setGetCategoryType) {
  loaderService.showLoader();
  apiClient
    .post(GET_STAKEHOLDER_BY_URN,
      {
        "urn": urn,
        "type": ""
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
    .then((response) => {
      setGetCategoryType(response.data);
      // console.log(response.data.stakeHolder.categoryName)
      loaderService.hideLoader();
    })
    .catch(function (error) {
      console.log(error);
      loaderService.hideLoader();
    });
}